import { render, staticRenderFns } from "./ipCategory.vue?vue&type=template&id=4a483e93&scoped=true"
import script from "./ipCategory.vue?vue&type=script&lang=js"
export * from "./ipCategory.vue?vue&type=script&lang=js"
import style0 from "./ipCategory.vue?vue&type=style&index=0&id=4a483e93&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a483e93",
  null
  
)

export default component.exports